module.exports = __webpack_public_path__ + "img/iconSystemPosition.1148e86c.svg";